import { AnyClass } from '@casl/ability/dist/types/types'
import { AnyIfEmpty } from 'react-redux'
import { Node as NodoBase } from 'reactflow'
import { Edge, MarkerType, XYPosition } from 'reactflow'

export interface InterfazUpdateCoordenadas {
    id: number
    posicionX: number
    posicionY: number
}

export interface EtapaView {
    id: number
    codSistema: number
    nombre: string
    posX: number
    posY: number
    nombreSistema: string
}
export interface AccionView {
    codSistema: number
    nombre: string
    idEtapaOrigen: number
    idEtapaDestino: number
    codAccionTipo: number
    nombreSistema: string
    nombreEtapaOrigen: string
    nombreEtapaDestino: string
    accionTipo: string
    rotulo: string
    id: number
}

export interface AccionValorView {
    idAccion: number
    valor: string
    descripcion: string
    codAcctionTipo: number
    idRolDestino: number
    idEtapaDestino: number
    nombreSistema: string
    nombreRolDstino: string
    nombreEtapaDestino: string
    accionTipo: string
    rotulo: string
    id: number
}

export enum TipoAccionId {
    DEFINIR = 5,
    DEVOLVER = 9
}

export enum PrefijoTipoNodo {
    ETAPA = 'etp',
    DEFINIR = 'act',
    DEVOLVER = 'ret'
}

export enum PrefijoTipoEdge {
    ACCION = 'act',
    ACCION_VALOR = 'act-val'
}

export enum TipoNodo {
    ETAPA = 'nodo-etapa',
    ACCION_VALOR = 'nodo-accion-valor',
    ACCION_RETORNO = 'nodo-accion-retorno'
}

export interface CustomNodeProperties {
    data: {
        label: string
        n_salidas: number
        n_entradas: number
    }
}

// TODO: Unificar con CustomNodeProperties

type NodeData = {
    label: string
    n_salidas: number
    n_entradas: number
}

export class ClaseNodoEtapa implements NodoBase {
    id: string
    position: XYPosition
    type: TipoNodo.ETAPA
    data: NodeData
    extent: 'parent' | undefined

    constructor(etapa: EtapaView) {
        this.id = PrefijoTipoNodo.ETAPA + etapa.id
        this.position = { x: etapa.posX, y: etapa.posY }
        this.type = TipoNodo.ETAPA
        this.data = {
            label: etapa.nombre,
            n_salidas: 1,
            n_entradas: 1
        }
        this.extent = 'parent'

        return this
    }
}

export class ClaseNodoDefinir implements NodoBase {
    id: string
    position: XYPosition
    type: TipoNodo.ACCION_VALOR
    data: NodeData
    parentNode: string
    draggable: false

    constructor(accion: AccionView, origen: NodoBase, anchoTexto: number) {
        this.id = PrefijoTipoNodo.DEFINIR + accion.id
        this.position = { x: 130 + anchoTexto, y: 10 }
        this.type = TipoNodo.ACCION_VALOR
        this.data = {
            label: 'definir',
            n_salidas: 1,
            n_entradas: 1
        }
        this.parentNode = origen.id
        this.draggable = false
    }
}

export class ClaseNodoDevolver implements NodoBase {
    id: string
    position: XYPosition
    type: TipoNodo.ACCION_RETORNO
    data: NodeData
    parentNode: string
    draggable: false

    constructor(accion: AccionView, origen: NodoBase) {
        this.id = PrefijoTipoNodo.DEVOLVER + accion.id
        this.position = { x: 45, y: -45 }
        this.type = TipoNodo.ACCION_RETORNO
        this.data = {
            label: 'devolver',
            n_salidas: 1,
            n_entradas: 1
        }
        this.parentNode = origen.id
        this.draggable = false
    }
}

export class ClaseEdgeAccion {
    id: string
    source: string
    target: string
    type: 'default'
    markerEnd: MarkerType.ArrowClosed
    className: string
    label?: string
    labelStyle?: any
    labelBgStyle?: any
    labelBgPadding?: any

    constructor(accion: AccionView, destino?: NodoBase) {
        this.id = PrefijoTipoEdge.ACCION + accion.id
        this.source = PrefijoTipoNodo.ETAPA + accion.idEtapaOrigen
        this.target =
            accion.codAccionTipo === 9
                ? PrefijoTipoNodo.DEVOLVER + accion.id
                : accion.idEtapaDestino
                ? PrefijoTipoNodo.ETAPA + accion.idEtapaDestino
                : destino
                ? destino.id.toString()
                : ''
        this.markerEnd = MarkerType.ArrowClosed
        this.type = 'default'
        this.className = 'regular'
    }
}

export class ClaseEdgeAccionValor {
    id: string
    source: string
    target: string
    type: 'default'
    markerEnd: MarkerType.ArrowClosed
    className: string
    label?: string
    labelStyle?: any
    labelBgStyle?: any
    labelBgPadding?: any

    constructor(accion: AccionValorView, origen: Edge) {
        this.id = PrefijoTipoEdge.ACCION_VALOR + accion.id
        this.source = origen.target
        this.target = PrefijoTipoNodo.ETAPA + accion.idEtapaDestino
        this.markerEnd = MarkerType.ArrowClosed
        this.type = 'default'
        this.className = 'regular'
    }
}
